export enum MediaState {
  None = 0,
  ItemsLoading = 1 << 0,
  Initialized = 1 << 1,
}
